/**
 * Sets up the routing for all admin views relating to the User resource.
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, Switch, withRouter } from 'react-router-dom';

// import global components
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import user admin views
import AdminCreateUser from './views/AdminCreateUser.js.jsx';
import AdminSingleUser from './views/AdminSingleUser.js.jsx';
import AdminUpdateUser from './views/AdminUpdateUser.js.jsx';
import AdminUserList from './views/AdminUserList.js.jsx';
import SingleModuleCertificate from '../moduleCertificate/views/SingleModuleCertificate.js.jsx';
import AdminSingleUserCertificateList from '../moduleCertificate/views/AdminSingleUserCertificateList.js.jsx';
import AdminSingleCertificateView from '../moduleCertificate/views/AdminSingleCertificateView.jsx';

class UserAdminRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    let singleUserCertPath = this.props.location.pathname.substring(this.props.location.pathname.indexOf('/cert'), 0);
    let singleUserUpdatePath = this.props.location.pathname.substring(this.props.location.pathname.indexOf('/update'), 0);
    return (
      <Switch>
        <YTRoute
          breadcrumbs={[{display: 'All users', path: null}]}
          component={AdminUserList}
          exact
          path="/admin/users"
          role="admin"
        />
        {/* <YTRoute
          breadcrumbs={[{display: 'All users', path: '/admin/users'},{display:'New', path:null}]}
          component={AdminCreateUser}
          exact
          path="/admin/users/new"
          role="admin"
        /> */}
        <YTRoute
          breadcrumbs={[{display: 'All users', path: '/admin/users'},{display:'User info', path:null}]}
          component={AdminSingleUser}
          exact
          path="/admin/users/:userId"
          role="admin"
        />
        {/* <YTRoute
          breadcrumbs={[{display: 'All users', path: '/admin/users'},{display:'User info', path:singleUserUpdatePath},{display:'Update', path:null}]}
          component={AdminUpdateUser}
          exact
          path="/admin/users/:userId/update"
          role="admin"
        /> */}
        <YTRoute
          component={AdminSingleUserCertificateList}
          path="/admin/users/:userId/certs"
          exact
          role="admin"
        />
        <YTRoute
          component={AdminSingleCertificateView}
          exact
          path="/admin/users/:userId/certs/:moduleCertificateId"
          role="admin"
        />
        {/* <YTRoute
          breadcrumbs={[{display: 'All users', path: '/admin/users'},{display:'User info', path:singleUserCertPath},{display:'Certificate of completion', path:null}]}
          component={SingleModuleCertificate}
          exact
          path="/admin/users/:userId/certs/:moduleCertificateId"
          role="admin"
        /> */}
      </Switch>
    )
  }
}

export default withRouter(UserAdminRouter);



// WEBPACK FOOTER //
// modules/user/UserAdminRouter.js.jsx